(function(){
  var {host, hostname, pathname, href} = window.location
  var vd = ["api_staples_ca","www_staples_ca","staples-canada_myshopify_com","www_worklearngrow_com","www_travaillierapprendreevoluer_com","bureauengrus.com","eak_bureauengros_com","eak_staples_ca","www_bureauengros_ca","www_businessdepot_ca","www_businessdepot_com","www_worklearngrow_online","worklearngrow_online","staples-canada-dev_myshopify_com","worklearngrow_com","locations_bureauengros_com","stores_staples_ca","sls-cms_production_sweetiq_com","sls-cms_staging_sweetiq_com"];
  var found = vd.filter(function(d){
    return d.replace(/\_/g, '.') === host;
  })

  if(hostname === '127.0.0.1' || hostname === 'localhost') {
    return;
  }

  if(!Boolean(found.length)){
    window.location = "https://" + vd[0].replace(/\_/g, '.');
  }

  var ff_redirect_from_bold_store_locator_app = true;
  if (ff_redirect_from_bold_store_locator_app) {
    if(pathname === "/apps/store-locator") {
      href = "https:\/\/stores.staples.ca";
    }
  }
})();
